import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]

  static values = {
    startedAt: String
  }

  connect() {
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.updateDisplay()
    this.intervalId = setInterval(() => {
      this.updateDisplay()
    }, 1000)
  }

  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  updateDisplay() {
    if (!this.hasDisplayTarget) return

    const elapsed = this.getElapsedSeconds()
    this.displayTarget.textContent = this.formatTime(elapsed)
  }

  getElapsedSeconds() {
    if (!this.startedAtValue) return 0

    const startedAt = new Date(this.startedAtValue)
    const now = new Date()
    return Math.floor((now - startedAt) / 1000)
  }

  formatTime(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }
}
